import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';
import { AuthProvider, useAuth } from '@/lib/auth';
import AppLayout from '@/components/AppLayout';
import PWAInstallPrompt from '@/components/PWAInstallPrompt';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import Home from '@/pages/Home';
import WorkoutMode from '@/pages/WorkoutMode';
import ExerciseManager from '@/pages/ExerciseManager';
import TemplateManager from '@/pages/TemplateManager';
import Progress from '@/pages/Progress';
import Settings from '@/pages/Settings';

function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Cargando…</div>;
    if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
    return children;
}

function Root() {
    useEffect(() => {
        document.documentElement.classList.add('dark');
        // Register service worker for PWA (best-effort)
        if ('serviceWorker' in navigator) {
            window.addEventListener('load', () => {
                navigator.serviceWorker.register('/sw.js').catch(() => {});
            });
        }
    }, []);
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
                <Route path="/" element={<Home />} />
                <Route path="/workout/:dayId" element={<WorkoutMode />} />
                <Route path="/exercises" element={<ExerciseManager />} />
                <Route path="/templates" element={<TemplateManager />} />
                <Route path="/progress" element={<Progress />} />
                <Route path="/settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App dark">
            <AuthProvider>
                <BrowserRouter>
                    <Root />
                    <PWAInstallPrompt />
                    <Toaster theme="dark" position="top-center" richColors closeButton />
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
